var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.4062mm",
    height: "10.274mm",
    viewBox: "0 0 9.4062 10.274",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient23566",
    x1: 83.26,
    x2: 83.26,
    y1: 91.239,
    y2: 82.895,
    gradientTransform: "translate(3.3403e-5 -.00023953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdada4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8e5",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80.876 -81.956)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#linearGradient23566)",
    stroke: "#ef2118",
    strokeLinejoin: "round",
    strokeWidth: 1.765,
    "aria-label": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.758 88.289c0 2.3388 0.46565 3.0585 3.9898 3.0585 2.0108 0 3.6511-0.27516 3.6511-2.4976 0-1.4922-0.79372-1.8097-1.1641-1.9473 1.0054-0.38099 1.0054-1.4499 1.0054-1.725 0-0.5609-0.16933-1.2382-0.64556-1.6827-0.52915-0.4974-1.2911-0.65615-2.9738-0.65615-2.8574 0-3.6406 0.50798-3.6829 2.8574h1.8838c0-0.71964 0-1.1112 1.6721-1.1112 1.2276 0 1.8626 0.01058 1.8626 0.85722 0 0.80431-0.5609 0.80431-1.016 0.80431h-1.6509v1.5028h1.6509c0.46565 0 1.143 0 1.143 0.89956 0 0.95247-0.85722 0.95247-1.7039 0.95247-1.9896 0-2.1272-0.09525-2.1166-1.3123z",
    strokeLinecap: "square",
    style: {
      paintOrder: "stroke markers fill"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.cf7e7e5c907371f532989ee9910ec31b.svg";
export { ForwardRef as ReactComponent };